import { createRoot } from 'react-dom/client';
import { App } from './App';
import { hydrateSiteContent } from './lib/siteContent';
import './styles/globals.css';

/**
 * Content is pulled from the CMS before the first render rather than per page:
 * the pages read plain modules, and this fills those in. It resolves either way,
 * so an unreachable API costs a short pause and nothing else.
 */
void hydrateSiteContent().then(() => {
    createRoot(document.getElementById('root')!).render(<App />);
});
